import React from "react";
import { GlassCard } from "../gc/ui";
import { computeDebt, DEFAULT_MILESTONES, DEFAULT_SHIP } from "../../lib/gamecraft";

export default function StudioBoard({ project, onChange, onJump }) {
  const cfg = project.config || {};
  const milestones = (cfg.milestones?.length ? cfg.milestones : DEFAULT_MILESTONES).map((m) => ({ ...m }));
  const ship = (cfg.ship?.length ? cfg.ship : DEFAULT_SHIP).map((s) => ({ ...s }));
  const log = cfg.playtest_log || [];
  const budget = cfg.budget || { enemies: 4, bosses: 1, sfx: 12 };
  const debt = computeDebt(project);
  const setCfg = (patch) => onChange({ config: { ...cfg, ...patch } });
  const toggle = (list, key, id) => list.map((x) => x.id === id ? { ...x, done: !x.done } : x);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <GlassCard className="p-4 space-y-2">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold">Deuda de producción</h3>
          <span className="gc-chip">{debt.total} items</span>
        </div>
        <p className="text-xs" style={{ color: "var(--gc-muted)" }}>
          {debt.noSprite.length} entidades sin sprite · {debt.noAnim ? "sin animaciones" : "OK anim"} · {debt.noAudio ? "poco audio" : "OK audio"} · {debt.untested} tareas abiertas
        </p>
        <div className="flex flex-wrap gap-2">
          <button className="gc-btn gc-btn-ghost h-9 px-3 text-xs" onClick={() => onJump("canvas")}>Ver kanban</button>
          <button className="gc-btn gc-btn-primary h-9 px-3 text-xs" onClick={() => onJump("engine")}>Playtest</button>
        </div>
        <label className="flex items-center gap-2 text-sm pt-2">
          <input type="checkbox" checked={!!cfg.scope_frozen} onChange={(e) => setCfg({ scope_frozen: e.target.checked })} />
          Scope freeze (no entra contenido nuevo)
        </label>
        <div className="grid grid-cols-3 gap-2 text-xs">
          {["enemies", "bosses", "sfx"].map((k) => (
            <label key={k} style={{ color: "var(--gc-muted)" }}>
              {k}
              <input
                className="gc-input h-8 mt-1 w-full"
                type="number"
                value={budget[k] ?? 0}
                onChange={(e) => setCfg({ budget: { ...budget, [k]: Number(e.target.value) } })}
              />
            </label>
          ))}
        </div>
      </GlassCard>

      <GlassCard className="p-4 space-y-2">
        <h3 className="font-semibold">Vertical slice</h3>
        {milestones.map((m) => (
          <label key={m.id} className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={!!m.done} onChange={() => setCfg({ milestones: toggle(milestones, "milestones", m.id) })} />
            {m.title}
          </label>
        ))}
      </GlassCard>

      <GlassCard className="p-4 space-y-2">
        <h3 className="font-semibold">Ship checklist</h3>
        {ship.map((m) => (
          <label key={m.id} className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={!!m.done} onChange={() => setCfg({ ship: toggle(ship, "ship", m.id) })} />
            {m.title}
          </label>
        ))}
      </GlassCard>

      <GlassCard className="p-4 space-y-2">
        <h3 className="font-semibold">Playtest log</h3>
        <button
          className="gc-btn gc-btn-ghost h-9 px-3 text-xs"
          onClick={() => {
            const note = window.prompt("Nota de playtest (3 puntos: qué se rompió, qué se sintió, qué cortar)");
            if (!note) return;
            setCfg({ playtest_log: [...log, { ts: new Date().toISOString(), note }] });
          }}
        >
          Añadir nota
        </button>
        <div className="space-y-1 max-h-36 overflow-auto gf-scroll">
          {log.slice(-6).reverse().map((x, i) => (
            <div key={i} className="text-xs" style={{ color: "var(--gc-muted)" }}>
              {new Date(x.ts).toLocaleString()} — {x.note}
            </div>
          ))}
          {!log.length && <p className="text-xs" style={{ color: "var(--gc-muted)" }}>Aún no hay sesiones.</p>}
        </div>
      </GlassCard>
    </div>
  );
}
